import { FunctionComponent } from 'react'

import styled from 'styled-components'

import ScoreboardMatchResultTennis from '@components/Scoreboard/ScoreboardMatchResultTennis'

import ScoreboardMatchStatus from './ScoreboardMatchStatus'

const StyledScoreboardMatchResult = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
`

const ScoreboardTennis: FunctionComponent = () => {
  return (
    <StyledScoreboardMatchResult>
      <ScoreboardMatchStatus />
      <ScoreboardMatchResultTennis />
    </StyledScoreboardMatchResult>
  )
}

export default ScoreboardTennis
